import { Activity, Award, BarChart3, FileText, Flag, LayoutDashboard, Settings, Target } from "lucide-react";
import { FC } from "react";
import { useAuth } from "../../auth";
import { useCanOpenDashboardTab } from "../core/tabRights";

/* eslint-disable @typescript-eslint/no-explicit-any */
type Props = {
  activeTab: any;
  handleNavigate: any
}
const DashboardMenu: FC<Props> = ({ activeTab, handleNavigate }) => {

  const { auth } = useAuth();
  const canOpenTab = useCanOpenDashboardTab();

  return (
    <div
      className="glass border-bottom d-none d-lg-block"
      style={{
        position: 'sticky',
        top: 'var(--kt-app-header-height, 65px)',
        zIndex: 1,
      }}
    >
      <div className="px-5 mx-5">
        <ul className="nav nav-tabs custom-nav row gx-1">
          {canOpenTab("dashboard") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4 ${activeTab === "dashboard" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("dashboard")}
            >
              <Activity size={16} className="me-2" />
              Pipeline Status
            </button>
          </li>}
          {canOpenTab("stagegates") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4 ${activeTab === "stagegates" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("stagegates")}
            >
              <Flag size={16} className="me-2" />
              Stage Gates
            </button>
          </li>}
          {canOpenTab("evaluation") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4 ${activeTab === "evaluation" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("evaluation")}
            >
              <Award size={16} className="me-2" />
              Panoptic Evaluation
            </button>
          </li>}
          {canOpenTab("projects") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4  ${activeTab === "projects" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("projects")}
            >
              <Target size={16} className="me-2" />
              Project Portfolio
            </button>
          </li>}
          {canOpenTab("prospectus") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4 ${activeTab === "prospectus" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("prospectus")}
            >
              <BarChart3 size={16} className="me-2" />
              Investor Prospectus
            </button>
          </li>}

          {canOpenTab("reports") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4  ${activeTab === "reports" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("reports")}
            >
              <FileText size={16} className="me-2" />
              Reports
            </button>
          </li>}
          <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4  ${activeTab === "kpi_monitoring" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("kpi_monitoring")}
            >
              <LayoutDashboard size={16} className="me-2" />
              Strat Plan KPI’s
            </button>
          </li>
          {auth?.user_details?.is_approver !== 'Yes' && canOpenTab("settings") && <li className="col-auto nav-item">
            <button
              className={`nav-link d-flex align-items-center border px-xl-5 px-lg-3 py-4 border-0 rounded-4 ${activeTab === "settings" ? "active" : "inactive"
                }`}
              onClick={() => handleNavigate("settings")}
            >
              <Settings size={16} className="me-2" />
              Settings
            </button>
          </li>}
        </ul>
      </div>
    </div>
  );
};

export { DashboardMenu };
